import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, X } from 'lucide-react';

/**
 * Preview Banner Component
 * Permanent banner at top with exit button
 */
const PreviewBanner = () => {
  const navigate = useNavigate();

  const handleExit = () => {
    navigate('/');
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2.5 sticky top-0 z-50">
      <div className="flex items-center justify-center gap-3">
        <div className="flex items-center gap-2 text-amber-700 text-sm">
          <Eye className="h-4 w-4" />
          <span className="font-medium">Preview mode</span>
          <span className="text-amber-600 hidden sm:inline">— example data only. Nothing is saved.</span>
        </div>
        <button
          onClick={handleExit}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium rounded-lg transition-colors"
        >
          <X className="h-4 w-4" />
          Exit Preview
        </button>
      </div>
    </div>
  );
};

export default PreviewBanner;
